<script lang="ts">
	import Button from "@components/common/Button.svelte";
	import { ButtonSize } from "@components/common/ButtonSize.js";
	import Formatted from "@components/common/Formatted.svelte";
	import { getTranslate } from "@utils/getTranslate.js";
	import { ButtonVariant } from "@core/schema/ButtonVariant.js";
	import type { Product } from "@core/schema/Product.js";
	import { toDateMonthYearFormat } from "@core/utils/toDateMonthYearFormat.js";
	import { Cart } from "../../cart/Cart.svelte.js";
	import { getGlobalTemplateProps } from "../../contexts/getGlobalTemplateProps.js";
	import translations from "./ClearForPreorder.translations.json" with { type: "json" };

	const translate = getTranslate(translations);
	const { tenant } = getGlobalTemplateProps();

	const {
		onclear,
		cartShippingStartsAt,
	}: { onclear(this: void): void; cartShippingStartsAt: Product["shippingStartsAt"] } = $props();
</script>

<p class="mt-5 text-fcrdarkgray">
	{#if cartShippingStartsAt}
		<Formatted
			text={translate("messagePreorderInCart", {
				shippingDate: toDateMonthYearFormat(cartShippingStartsAt, tenant.locale),
			})}
		/>
	{:else}
		<Formatted text={translate("messageProductsInCart")} />
	{/if}
</p>
<div class="flex flex-col sm:flex-row sm:justify-end gap-4 mt-8">
	<Button
		variant={ButtonVariant.Outlined}
		size={ButtonSize.Medium}
		onclick={(): void => {
			onclear();
			Cart.closeCartModal();
		}}
	>
		<Formatted text={translate("clear")} />
	</Button>
	<Button
		variant={ButtonVariant.Dark}
		size={ButtonSize.Medium}
		onclick={(): void => {
			Cart.closeCartModal();
		}}
	>
		<Formatted text={translate("ok")} />
	</Button>
</div>
